import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'app/config';
import { Booking, ContactInfo, Customer, LoanApp, Vehicle } from 'app/models/customer';
import { LoanApplication } from 'app/models/loan-application';
import { lastValueFrom } from 'rxjs';
import { UtilService } from './util.service';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class CustomerService {

    constructor(
        private _httpClient: HttpClient,
        private _utilService: UtilService,
        private _storageService: StorageService,
    ) {
    }

    getLoanApplication(loanApplicationId: string): Promise<LoanApplication> {
        return lastValueFrom(this._httpClient.get<LoanApplication>(ApiUrls.LOAN_APPLICATION + loanApplicationId));
    }

    customerCreate(payload: any): Promise<any> {
        return lastValueFrom(this._httpClient.post<any>(ApiUrls.CUSTOMER_CREATE, payload));
    }

    applyLoanApplication(vehicleId: string): Promise<LoanApp> {
        return lastValueFrom(this._httpClient.post<LoanApp>(ApiUrls.APPLY_LOAN_APPLICATION + vehicleId, {}));
    }

    updateLoanApplication(payload: any): Promise<any> {
        return lastValueFrom(this._httpClient.patch<any>(ApiUrls.UPDATE_LOAN_APPLICATION, payload));
    }

    submitLoanApplication(loanApplicationId: string): Promise<any> {
        return lastValueFrom(this._httpClient.post<any>(ApiUrls.SUBMIT_LOAN_APPLICATION + loanApplicationId, {}));
    }

    deleteLoanApplicationMedia(loanApplicationId: string, mediaId: string): Promise<any> {
        return lastValueFrom(this._httpClient.delete(this._utilService.formatString(ApiUrls.DELETE_LOAN_APPLICATION_MEDIA, loanApplicationId.trim(), mediaId.trim())));
    }

    getContactInfo(idNumber: string): Promise<ContactInfo> {
        return lastValueFrom(this._httpClient.get<ContactInfo>(ApiUrls.GET_CONTACT_INFO + idNumber));
    }

    getBookings(customerId: string): Promise<Array<Booking>> {
        return lastValueFrom(this._httpClient.get<Array<Booking>>(ApiUrls.GET_BOOKINGS + customerId));
    }

    getBookingDetails(bookingId: string): Promise<Booking> {
        return lastValueFrom(this._httpClient.get<Booking>(ApiUrls.GET_BOOKING_DETAILS + bookingId));
    }

    async loadBookingDetails() {
        try {
            const bookingId = await this._storageService.getBooking();
            if (bookingId) {
                let vehicle = await this.getBookingDetails(bookingId);
                this._utilService.setBookingDetails(vehicle);
            }
        } catch (e) {
            console.error(e);
        }
    }
}
